import { DialogComponent } from "@theme/dialog";

if (!customElements.get('surprise-dialog')) {
  class SurpriseDialog extends DialogComponent {
    constructor() {
      super();
    }

    open() {
      super.open();
      this.querySelector('surprise-product')?.showRandomProduct();
    }
  }
  customElements.define('surprise-dialog', SurpriseDialog);
}